// LLM generated - Model Claude 4 Sonnet
import { useIsMobile } from '~/domains/common/hooks/mediaQueries';

import { useContestChatContext } from '../components/ContestChat/ContestChatContext';

/**
 * Hook to determine if the chat widget is visible on the current page
 * Used to apply safe area padding to prevent content overlap
 *
 * This hook consumes ContestChatContext to avoid duplicate API calls
 * and Pusher subscriptions that would occur with useContestHuddlePusher
 */
export function useChatWidgetVisible() {
  const isMobile = useIsMobile();
  const { isLoadingChats, chatsData, finalIsChatWebEnabled } = useContestChatContext();

  const showChat = finalIsChatWebEnabled && !isLoadingChats && !!chatsData?.data?.length;
  const showChatWidget = isMobile && showChat;

  return showChatWidget;
}
